import { defineStore } from 'pinia'
import { ref } from 'vue'

type NotificationType = 'success' | 'error' | 'warning' | 'info'

export const useNotificationStore = defineStore('notification', () => {
  const show = ref(false)
  const message = ref('')
  const color = ref<NotificationType>('info')
  const timeout = ref(5000)

  function notify(msg: string, type: NotificationType = 'info', duration = 5000) {
    message.value = msg
    color.value = type
    timeout.value = duration
    show.value = true
  }

  function success(msg: string) {
    notify(msg, 'success')
  }

  function error(msg: string) {
    notify(msg, 'error', 8000)
  }

  function warning(msg: string) {
    notify(msg, 'warning')
  }

  function info(msg: string) {
    notify(msg, 'info')
  }

  function hide() {
    show.value = false
  }

  return {
    show,
    message,
    color,
    timeout,
    notify,
    success,
    error,
    warning,
    info,
    hide,
  }
})
